export const encryptionKey = "ly4@&gr$vnh905RyB>?%#@-(KSMT";
export const Dot_Pe_Number="919944885059"
export const Dot_Pe_Api_Key='dpmat-⁠LVH7khk3LDWnJGcyCqzh9cQUraPNhBViwO3wzkkVqZWALCvNVsXuCEE9JKgPYxk4qLuXdhmB25UM9O8lKK840y'    
export const merchantId="22000"

export const REACT_APP_ASKEVA_TOKEN = "ab232386697556df6e520afa18b48c46437849656eaf7a610c1d6150937aa2d11c2d4b3051674dfe37c020228da69c8fcda367a40a7e6a727ae020bcd7e27094";   
export const REACT_APP_ASKEVA_API_ENDPOINT = "https://backend.askeva.io/v1/message/send-message";
export const print_app="https://printapp.erpsmt.in"
